module.exports = __webpack_public_path__ + "img/Providus Bank Plc.0e7b8bb5.png";